import React from "react";
import Translate from "react-translate-component";
export const BondCancelOffer = ({
  op
}) => {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: "proposal.bond_cancel_offer"
  }), "\xA0", op[1].offer_id);
};